import { render } from "./Pedigree.vue?vue&type=template&id=1e33b4ac&scoped=true"
import script from "./Pedigree.vue?vue&type=script&lang=js"
export * from "./Pedigree.vue?vue&type=script&lang=js"

import "./Pedigree.vue?vue&type=style&index=0&id=1e33b4ac&scoped=true&lang=css"

import exportComponent from "D:\\VueLearning\\SheepbaseVueJs\\SheepBaseVueApp\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1e33b4ac"]])

export default __exports__